import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const getSafeBackUrl = (rawBackUrl) => {
  if (!rawBackUrl) return "/";

  try {
    const decodedUrl = decodeURIComponent(rawBackUrl);
    const parsedUrl = new URL(decodedUrl);

    if (parsedUrl.origin !== window.location.origin) {
      return "/";
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch {
    return "/";
  }
};

export const HelloAssoErrorPage = () => {
  const [searchParams] = useSearchParams();

  const backUrl = useMemo(() => {
    const rawBackUrl = searchParams.get("back_url");
    return getSafeBackUrl(rawBackUrl);
  }, [searchParams]);

  return (
    <div className="min-h-screen flex align-items-center justify-content-center p-3 surface-ground">
      <Card className="w-full md:w-8 lg:w-6">
        <div className="flex flex-column align-items-center text-center gap-3 p-2">
          <i className="pi pi-times-circle text-5xl text-red-500"></i>
          <h1 className="text-2xl m-0">Erreur de paiement</h1>
          <p className="text-700 m-0">
            Une erreur est survenue lors de votre paiement. Vous pouvez revenir à votre espace famille pour réessayer.
          </p>
          <div className="flex gap-2 mt-2">
            <Button
              label="Revenir à l'espace famille"
              icon="pi pi-arrow-left"
              onClick={() => {
                window.location.assign(backUrl);
              }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};
